import { useWindowSize } from "./useWindowSize";

const MOBILE_WIDTH_LIMIT = 768;

export function useIsMobile() {
  const width = useWindowSize();
  return width <= MOBILE_WIDTH_LIMIT;
}
